import DaaSTable, { DaasTableColumn } from '@/components/table/DaasTable';
import { Product } from '@/services/api/contracts/catalog/types';
import { useCategories } from '@/services/api/hooks/catalog';
import { usePoSelectedDevicesGroupedByCategory } from '@/services/purchaseOrders/usePurchaseOrderService';
import { Fragment, FunctionComponent } from 'react';
import { useParams } from 'react-router';
import { PurchaseOrderConfirmOrderDeviceTableCategorySectionRow } from './PurchaseOrderConfirmOrderDeviceTableCategorySectionRow';
import { PurchaseOrderConfirmOrderDeviceTableRow } from './PurchaseOrderConfirmOrderDeviceTableRow';

export interface PurchaseOrderConfirmOrderDeviceTableGroupedData {
  id: string;
  productRef: Product;
}

const tableHeaders: DaasTableColumn[] = [
  {
    accessor: 'deviceName',
    text: 'Description',
    size: '1fr'
  },
  {
    accessor: 'sku',
    text: 'SKU',
    size: '0.4fr'
  },
  {
    accessor: 'quantity',
    text: 'Qty',
    size: '0.3fr'
  },
  {
    accessor: 'deviceCost',
    text: 'Cost',
    size: '0.3fr'
  },
  {
    accessor: 'totalCost',
    text: 'Total',
    size: '0.3fr'
  },
  {
    accessor: 'pcm',
    text: 'PCM',
    size: '0.3fr'
  },
  {
    accessor: '',
    sortable: false,
    text: '',
    size: '0.1fr'
  }
];

interface PurchaseOrderConfirmOrderDeviceTableProps {}

export const PurchaseOrderConfirmOrderDeviceTableGrouped: FunctionComponent<
  PurchaseOrderConfirmOrderDeviceTableProps
> = () => {
  const { orderId } = useParams();
  if (!orderId) throw new Error('Missing order id');

  const [categories] = useCategories();

  const groupedProducts = usePoSelectedDevicesGroupedByCategory();

  return (
    <DaaSTable headers={tableHeaders} className="w-[calc(100%-40px)]">
      {Object.entries(groupedProducts).map(([categoryName, items]) => {
        const categoryLookup = categories.find(cat => cat.name === categoryName);
        if (!categoryLookup) throw new Error(`Category lookup failed for ${categoryName}`);

        const manufacturerIds = Array.from(new Set(items.map(item => item.manufacturer.id)));

        return (
          <Fragment key={`${categoryName}`}>
            <PurchaseOrderConfirmOrderDeviceTableCategorySectionRow
              manufacturerIds={manufacturerIds}
              category={categoryLookup}
            />
            {items.map(item => (
              <PurchaseOrderConfirmOrderDeviceTableRow
                data={{
                  id: item.id,
                  productRef: item
                }}
                key={item.id}
              />
            ))}
          </Fragment>
        );
      })}
    </DaaSTable>
  );
};
